"use client";
import t, { useEffect as r } from "react";
import a from "./index.es102.js";
const f = ({
  sections: s,
  className: o,
  richtextSections: i
}) => {
  const l = s.filter((e) => e?.displayTitle);
  r(() => {
    const e = window.location.hash;
    if (e) {
      const c = document.getElementById(e.slice(1));
      c && c.scrollIntoView({ behavior: "smooth", inline: "nearest" });
    }
  }, [l, i]);
  const n = i.filter(
    (e) => e.includeLink
  );
  return l.length + n.length > 1 ? /* @__PURE__ */ t.createElement("div", { className: o }, /* @__PURE__ */ t.createElement("h2", { className: "bl-size-3 bl-p-b-3" }, "På denne siden:"), /* @__PURE__ */ t.createElement("ul", { className: "bl-link-list bl-link-list--two-column" }, l.map((e) => /* @__PURE__ */ t.createElement("li", { key: e.id }, /* @__PURE__ */ t.createElement(a, { href: `#section-${e.id}` }, e.displayTitle))), n.map((e) => /* @__PURE__ */ t.createElement("li", { key: `richtext-${e.id}` }, /* @__PURE__ */ t.createElement(a, { href: `#section-richtext-${e.id}` }, e.title))))) : null;
};
export {
  f as default
};
//# sourceMappingURL=index.es50.js.map
